var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$attrs.value)?_c('v-dialog',_vm._g(_vm._b({attrs:{"no-click-animation":"","transition":"dialog-bottom-transition"}},'v-dialog',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }